import * as React           from 'react'
import { FormattedMessage } from 'react-intl'

import Button                              from '@material-ui/core/Button/Button'
import Grid                                from '@material-ui/core/Grid'
import Typography                          from '@material-ui/core/Typography'
import { FieldArray, InjectedFormikProps } from 'formik'

import { CoachingCertificate }             from '../../../api'
import withToggle, { InjectedToggleProps } from '../../hocs/withToggle'
import CoachingCertificateCard             from '../../molecules/CoachingCertificateCard'
import AddCoachingCertificateDialog        from '../CoachingCertificateAddDialog'
import { i18nErrorCodes }                  from '../form-utils'

type Props =
  InjectedFormikProps<InjectedToggleProps, { coachingCertificates: CoachingCertificate [] }>

const ExperiencesChunk = (props: Props) => {
  const {
    errors,
    activate,
    deactivate,
    isActive,
    values:
      {
        coachingCertificates,
      },
  } = props

  const phrasing = {
    coachingCertificates: <FormattedMessage id={'project.coachingCertificates'} />,
    add:                  <FormattedMessage id={'buttonActions.add'} />,
  }

  return (
    <FieldArray
      name={'coachingCertificates'}
      render={({
        push,
        remove,
      }) => (
        <Grid
          container
          direction={'column'}
          spacing={16}
        >
          <Grid item>
            <Grid
              container
              justify={'space-between'}
            >
              <Grid item>
                <Typography variant={'subheading'}>
                  {phrasing.coachingCertificates}
                </Typography>
              </Grid>
              <Grid>
                <Button onClick={activate} color={'secondary'}>
                  {phrasing.add}
                </Button>
              </Grid>
            </Grid>
          </Grid>

          {coachingCertificates.map((certificate, i) => (
            <Grid item key={i}>
              <CoachingCertificateCard
                onRemove={() => {
                  remove(i)
                }}
                coachingCertificate={certificate}
              />
            </Grid>
          ))}

          {errors.coachingCertificates && (
            <Grid item>
              <Typography variant={'subheading'} color={'error'}>
                <FormattedMessage id={'validation.' + i18nErrorCodes.minOneExperienceRequired} />
              </Typography>
            </Grid>
          )}

          <AddCoachingCertificateDialog
            isOpen={isActive}
            close={deactivate}
            onClose={deactivate}
            onSubmit={values => {
              deactivate()
              push(values)
            }}
          />
        </Grid>
      )}
    />
  )
}

export default withToggle(ExperiencesChunk)



// WEBPACK FOOTER //
// ./src/components/forms/chunks/CoachingCertificateChunk.tsx